(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__flagLazy) return;
  window.__flagLazy = true;
  function hydrate(scope) {
    var els = scope.querySelectorAll('.f-country-flags[data-flag]');
    for (var i = 0; i < els.length; i++) {
      els[i].style.setProperty('--background-image', 'url(' + els[i].getAttribute('data-flag') + ')');
      els[i].removeAttribute('data-flag');
    }
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.querySelector && d.querySelector('.f-country-flags[data-flag]')) hydrate(d);
  }, true);
  document.addEventListener('pointerdown', function (e) {
    var t = e.target && e.target.closest && e.target.closest('localization-form, details, .country-switcher');
    if (t && t.querySelector('.f-country-flags[data-flag]')) hydrate(t);
  }, { capture: true, passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-icons-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pig-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-pig-open'));
      if (m) { document.body.appendChild(m); m.hidden = false; document.documentElement.style.overflow = 'hidden'; }
      return;
    }
    var modal = e.target.closest('[data-pig-modal]');
    if (!modal) return;
    if (e.target.closest('[data-pig-close]') || !e.target.closest('.product-icons-grid__modal-card')) {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-pig-modal]:not([hidden])');
    if (open) { open.hidden = true; document.documentElement.style.overflow = ''; }
  });
  } catch(e) { console.error(e); }
})();

})();
